import { Action } from '@/_core/fluxstore/types';
import { CsrfTokenDialogState } from '../types';

import { useCsrfTokenDialogModule } from '..';
const { registerReducer } = useCsrfTokenDialogModule();

export class OpenCsrfTokenDialog extends Action<CsrfTokenDialogState> {
    public static ACTION_TYPE = 'CsrfTokenDialogState::Open';

    public constructor() {
        super(OpenCsrfTokenDialog.ACTION_TYPE);
    }
}

// eslint-disable-next-line
const reducer = (state: CsrfTokenDialogState, action: OpenCsrfTokenDialog): void => {
    state.isOpen = true;
};

//@ts-ignore
registerReducer(OpenCsrfTokenDialog.ACTION_TYPE, reducer);
